import type { BasicPalette } from '@theme/theme.types'
import type { DynamicMatcher, Preset } from 'unocss'

const paletteCssMapping: BasicPalette = {
  base: 'var(--p-base)',
  primary: 'var(--p-primary)',
  primary2: 'var(--p-primary2)',
  primary3: 'var(--p-primary3)',
  primary4: 'var(--p-primary4)',
  primary5: 'var(--p-primary5)',
  primary6: 'var(--p-primary6)',
  primary6_1: 'var(--p-primary6_1)',
  accent: 'var(--p-accent)',
  text: 'var(--p-text)',
  text2: 'var(--p-text2)',
  text3: 'var(--p-text3)',
  error: 'var(--p-error)',
  error2: 'var(--p-error2)',
  error3: 'var(--p-error3)',
  warning: 'var(--p-warning)',
  warning2: 'var(--p-warning2)',
  warning3: 'var(--p-warning3)',
  success: 'var(--p-success)',
  success2: 'var(--p-success2)',
  success3: 'var(--p-success3)',
  info: 'var(--p-info)',
  info2: 'var(--p-info2)',
  info3: 'var(--p-info3)',
  boxShadow: 'var(--p-boxShadow)',
  boxShadow2: 'var(--p-boxShadow2)',
  boxShadow3: 'var(--p-boxShadow3)',
}
const colorPaletteKeys = Object.keys(paletteCssMapping)

function colorRuleFor(propertyName: string): DynamicMatcher<object> {
  return ([, c]) => {
    if (paletteCssMapping[c as keyof BasicPalette]) {
      return { [propertyName]: `var(--p-${c})` }
    }
  }
}

export default (): Preset => {
  return {
    name: 'pitcher-uno-css-preset',
    safelist: [
      ...colorPaletteKeys.map((colorName) => `bg-${colorName}`),
      ...colorPaletteKeys.map((colorName) => `color-${colorName}`),
      ...colorPaletteKeys.map((colorName) => `border-${colorName}`),
    ],
    rules: [
      [/^color-(.*)$/, colorRuleFor('color')],
      [/^bg-(.*)$/, colorRuleFor('background-color')],
      [/^border-(.*)$/, colorRuleFor('border-color')],
    ],
  }
}
